module.exports = __webpack_public_path__ + "a3cf8449c856a1216648b149b79ae305.png";